import classNames from 'classnames';
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import {
  useLastNotifications,
  useMarkNotificationAsRead,
} from '../../../hooks/useNotifications';
import { usePermissions } from '../../../hooks/usePermissions';
import {
  BACKOFFICE_PERMISSIONS,
  PERMISSIONS,
} from '../../../utils/permissions';
import { Wordmark } from '../brand/Wordmark';
import { NotificationTooltip } from '../Notifications/NotificationTooltip';
import { LoginButton } from './LoginButton';
import { ThemeToggle } from './ThemeToggle';

/** The worklist's sections, each for those its permissions let in (the backoffice: any of its sections'). */
const LINKS: { to: string; label: string; end?: boolean; anyOf?: string[] }[] =
  [
    { to: '/', label: 'Home', end: true },
    {
      to: '/my-label-tasks',
      label: 'My tasks',
      anyOf: [PERMISSIONS.LIST_OWN_LABEL_TASK],
    },
    {
      to: '/notifications',
      label: 'Notifications',
      anyOf: [PERMISSIONS.READ_NOTIFICATION],
    },
    {
      to: '/backoffice',
      label: 'Backoffice',
      anyOf: BACKOFFICE_PERMISSIONS,
    },
    // every role's: each reader gets the pages written for what they can do
    { to: '/docs', label: 'Help' },
  ];

export function GdataHeader() {
  const { data, isLoading } = useLastNotifications();
  const lastNotifications = data?.content ?? [];
  const { mutate: markAsRead } = useMarkNotificationAsRead();
  const { has } = usePermissions();

  return (
    <header className="sticky top-0 z-20 bg-dh-plum text-white shadow-sm">
      <div className="flex min-h-[64px] flex-wrap items-center gap-6 px-6">
        <Link to="/" className="shrink-0 text-[24px] leading-none">
          <Wordmark />
        </Link>
        <nav
          aria-label="Main"
          className="flex flex-1 flex-wrap items-center gap-1"
        >
          {LINKS.filter(link => !link.anyOf || link.anyOf.some(has)).map(
            link => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.end}
                className={({ isActive }) =>
                  classNames('rounded-lg px-3 py-2 text-lg transition', {
                    'bg-white/20 font-semibold': isActive,
                    'font-medium text-white/80 hover:bg-white/10 hover:text-white':
                      !isActive,
                  })
                }
              >
                {link.label}
              </NavLink>
            )
          )}
        </nav>
        <div className="flex items-center gap-1.5">
          <ThemeToggle />
          <NotificationTooltip
            disabled={isLoading || !data}
            notifications={lastNotifications}
            onNotificationRead={id => {
              markAsRead(id);
            }}
          />
          <LoginButton />
        </div>
      </div>
    </header>
  );
}
